//import * as Helper from "../../_Helper";
import http from "../HttpService";
/*
const data = [
  {
    id: 1,
    tenantId: 6,
    text:
      "<b>Standardní služby</b><br /> V naší ordinaci Vám nabízíme kvalitní komplexní lékařské služby. Vždy profesionální a osobní přístup je u nás samozřejmostí. Ke každému pacientovi přistupujeme individuálně v řešení jeho zdravotních problémů. To vše je možné s pomocí kvalitních a ověřených zdravotnických přístrojů.<br />                      <b>Ošetření a vyšetření praktickým lékařem</b><br /> <br />      V naší ordinaci poskytujeme léčebně-preventivní péči praktického lékaře pro dospělé hrazené ze zdravotního pojištění i nadstandardní placené služby.      diagnostika a léčba akutních onemocnění      komplexní péče o pacienty s hronickým onemocněním (arteriální hypertenze, poruchy metabolismu lipidů, obesita, nekomplikovaný diabetes mellitus 2. typu, chronická žilní onemocnění, bolestivé stavy, deprese a poruchy spánku).<br /><br />        <b>Rozsáhlé přístrojové vybavení:</b><br />            EKG - vyšetření srdeční činnosti<br />      OCT - laboratorní vyšetření přímo v ordinaci s výsledkem na počkání - (CRP, INR, glykémie, FOB test - skryté krvácení ve stolici, orientační vyšetření moči)<br />      Odběry krve a moči, kultivační vyšetření<br />      Prstový oxymetr - přístroj ke stanovení okysličení krve kyslíkem<br />      ABI - přístroj na ěření indexu kotník paže - pro diagnózu schemické choroby dolních končetin<br />      24h ambulantní monitoring krevního tlaku - tzv. „Holter“<br />      Tacionální antibiotická terapie respiračních a kožních infekcí<br />      Předoperační vyšetření<br />      Preventivní a vyhledávací postupy nádorových nemocnění<br />      Pravidelné preventivní prohlídky pro všechny věkové kategorie<br />      Prohlídky k potvrzení řidičského a zbrojního průkazu<br />      Prohlídky k vystavení zdravotního průkazu<br />      Prohlídky do zaměstnání, pro sportovní aktivity apod.<br />      Očkování<br />      Posudková innost, sepsání návrhu na lázeňskou péči<br />      Ošetření nepojištěných osob (přímo hrazená péče)<br />",
  },
];*/

const controller = "/ourservice/";

function getUrl(tenantId) {
  return `${controller}${tenantId}`;
}

export function getItem(tenantId) {
  return http.get(getUrl(tenantId));
}

export function deleteData(tenantId) {
  return http.delete(getUrl(tenantId));
}

export function save(item) {
  if (item.id) {
    console.log("save about put ", item);
    return http.put(getUrl(item.id), item);
  } else {
    console.log("save about post ", item);
    return http.post(controller, item);
  }
}
/*
export function getData(tenantId) {
  return data.filter((m) => m.tenantId === tenantId).sort((a, b) => b.id - a.id);
}

export function deleteData(id) {
  let item = data.find((m) => m.id === id);
  data.splice(data.indexOf(item), 1);
  return item;
}

export function getItem(tenantId) {
  return data.find((m) => m.tenantId === tenantId);
}

export function save(item) {
  let itemInDb = data.find((m) => m.id === item.id) || {};
  //update
  if (itemInDb.id > 0) {
    deleteData(item.id);
    itemInDb = item;
  } else {
    //insert
    itemInDb = item;
    itemInDb.id = Helper.createId();
  }

  data.push(itemInDb);

  return itemInDb;
}
*/
